<template>
  <b-modal id="activity-modal" :visible="visible" @hide="$emit('close')" hide-footer title="Activity Log" centered>
    <div class="activity-content">
      <template v-if="data.length > 0">
        <div class="history-item" v-for="item in data" :key="item.id">
          <p>
            <strong>{{item.updated_by_name}}</strong> modified the split to <strong>{{ item.split.from }} / {{ item.split.to }}</strong>
          </p>
          <div class="date-row">
            <span class="date-icon"><i class="fa fa-calendar me-2"></i></span>
            <span>{{ item.history_updated_at }}</span>
          </div>
          <label class="reason-label">REASON</label>
          <div class="reason-box">
            {{ item.reason }}
          </div>
        </div>
        <hr />
      </template>
      <template v-else>
        <div class="reason-box">No activity found</div>
      </template>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <b-button variant="secondary" @click="$emit('close')">Close</b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "AllSeller",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => ({}),
    },
  },
};
</script>
<style>
#activity-modal .modal-body {
  padding-top: 0 !important;
}

.required {
  color: red;
}

.form-input {
  max-width: 100% !important;
}

.cancel-btn {
  background-color: #6c757d !important;
  color: #fff !important;
  border-radius: 6px;
}

.sub-header {
  font-weight: 600;
  font-size: 14px;
}

.cancel-btn .v-btn__content {
  color: #fff !important;
}

.history-item {
  font-family: Arial, sans-serif;
  margin-bottom: 20px;
}

.date-row {
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
  margin: 6px 0;
}

.date-icon {
  margin: 0 2px 0 0.5px;
  font-size: 16px;
}

.reason-label {
  font-size: 12px;
  font-weight: bold;
  color: #666;
  display: block;
  margin-top: 10px;
}

.reason-box {
  background: #f5f7fa;
  border-left: 3px solid #b0c6e1;
  border-radius: 5px;
  padding: 10px;
  font-size: 14px;
  color: #333;
  margin-top: 5px;
}

hr {
  border: none;
  border-top: 1px solid #ddd;
  margin: 20px 0;
}

#activity-modal .activity-content {
  padding-top: 0 !important;
  max-height: 480px;
  overflow: scroll;
  overflow-x: hidden;
}

/* 
.scroll-container {
  max-height: 250px;
  overflow-y: auto;
  padding-right: 5px;
} */
</style>
